import React from 'react';
import PropTypes from 'prop-types';

import equal from 'deep-equal';
import clone from 'clone-deep';

import { unique, dig } from 'spiceutils';

import ListEditor from '../ListEditor';
import SelectedItemDisplayList from '../ListEditor/SelectedItemDisplayList';
import OpenListEditorButton from '../ListEditor/OpenListEditorButton';
import MultiselectContainer from './MultiselectContainer';
import AddItemButton from '../../AddItemButton';

import PresetList from './PresetList';

class BreakList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showListEditor: false,
      internalBreakList: props.cdf.BreakList || [],
    };
  }
  componentWillReceiveProps(newProps) {
    // If list editor not open and cdf has changed
    if (!this.state.showListEditor && !equal(this.props.cdf, newProps.cdf)) {
      this.setState({ internalBreakList: newProps.cdf.BreakList || [] });
    }
  }
  onAdd() {
    // if there isn't already an empty break group in the list
    if (this.state.internalBreakList.filter((v) => v.length === 0).length === 0) {
      const internalBreakList = this.state.internalBreakList ? clone(this.state.internalBreakList) : [];
      internalBreakList.push([]);
      this.setState({ internalBreakList });
    }
  }
  onChange(index, val) {
    const internalBreakList = clone(this.state.internalBreakList);
    internalBreakList[index] = val;
    this.setState({ internalBreakList });
  }
  onRemove(index) {
    const internalBreakList = clone(this.state.internalBreakList);
    internalBreakList.splice(index, 1);
    this.setState({ internalBreakList });
  }
  getBreakControlByName(breakGroupName) {
    return this.props.controlList.BreakList.Options.AllSurveys.filter((bk) =>
      Object.keys(bk)[0] === breakGroupName
    )[0];
  }
  getTitle(breakListGroup) {
    /* Obtain the nice name of the group from the BreakList by going through our controllist
     * the data we have is
     * [
     *   {TOTAL: "text for total},
     * ]
     * and we want to to display the BreakGroupLabel for TOTAL found in CH controlList object as:
     *
     * TOTAL: {BreakGroupLabel: "Total", BreakAnswers: Array(1)
     */
    const breakGroupNames = unique(breakListGroup.map((breakGroup) => Object.keys(breakGroup)[0]));

    // Map over break group names
    const title = breakGroupNames.map((breakGroupName) => {
      const breakControl = this.getBreakControlByName(breakGroupName);
      // Get label of break
      return Object.values(breakControl)[0].BreakGroupLabel;
    }).join(', ');

    return title.length > 0 ? title : 'Select customer group';
  }
  toggleListEditor() {
    this.setState({
      // Reload our internal break list when exiting/entering modal
      internalBreakList: this.props.cdf.BreakList || [],
      showListEditor: !this.state.showListEditor,
    });
  }
  render() {
    if (dig(this.props.controlList, ['BreakList', 'Visible']) === true) {
      let listEditor = null;
      if (this.state.showListEditor) {
        listEditor = (
          <ListEditor modalTitle="Choose your customer groups." modalSubtitle="Use the 'Add Group' button to add a customer group." toggleListEditor={() => this.toggleListEditor()} >
            <SelectedItemDisplayList
              arrayList={this.state.internalBreakList ? clone(this.state.internalBreakList) : []}
              cdf={this.props.cdf}
              updateCDF={this.props.updateCDF}
              controlList={this.props.controlList.BreakList}
              getTitle={(blg) => this.getTitle(blg)}
              template={MultiselectContainer}
              onChange={(i, v) => this.onChange(i, v)}
              onRemove={(i) => this.onRemove(i)}
              field="BreakList"
              mode="edit"
            />
            <AddItemButton onClick={() => this.onAdd()}></AddItemButton>
          </ListEditor>
        );
      }
      return (
        <div>
          <label htmlFor="CustomerList">Currently selected customer groups</label>
          <SelectedItemDisplayList
            arrayList={this.props.cdf.BreakList || []}
            updateCDF={this.props.updateCDF}
            getTitle={(blg) => this.getTitle(blg)}
            onRemove={(i) => this.onRemove(i)}
            field="BreakList"
            mode="display"
            name="CustomerList"
          />
          <OpenListEditorButton toggleListEditor={() => this.toggleListEditor()} />
          <PresetList updateCDF={this.props.updateCDF} />
          {listEditor}
        </div>
      );
    }
    return null;
  }
}

BreakList.propTypes = {
  cdf: PropTypes.object,
  updateCDF: PropTypes.func,
  controlList: PropTypes.object,
};

export default BreakList;



// WEBPACK FOOTER //
// ./app/components/FormControls/BreakList/index.js